// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v9ZU","questions":"styles_questions__2UXbr","footer":"styles_footer__2Ucfh"};